import { render } from "./TestDataPrintView.vue?vue&type=template&id=f54fb94e"
import script from "./TestDataPrintView.vue?vue&type=script&lang=js"
export * from "./TestDataPrintView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__